function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M8.424 1.25h7.053c3.233 0 4.924.404 5.871 1.352.948.948 1.352 2.639 1.352 5.871v7.054c0 3.232-.404 4.923-1.352 5.871-.947.948-2.638 1.352-5.871 1.352H8.424c-3.233 0-4.924-.404-5.872-1.352-.947-.948-1.352-2.639-1.352-5.871V8.473c0-3.232.405-4.923 1.352-5.871C3.5 1.654 5.191 1.25 8.424 1.25z",
  stroke: "currentColor",
  strokeWidth: 1.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.285 8.424c.107-.356 0-.617-.507-.617h-1.677c-.426 0-.623.226-.73.475 0 0-.852 2.079-2.06 3.429-.391.39-.57.515-.782.515-.107 0-.261-.124-.261-.48V8.424c0-.427-.124-.617-.48-.617h-2.635c-.266 0-.427.198-.427.386 0 .404.604.497.667 1.634v2.47c0 .542-.098.64-.311.64-.569 0-1.952-2.088-2.772-4.478-.16-.464-.322-.652-.75-.652H4.881c-.479 0-.575.226-.575.475 0 .444.569 2.647 2.648 5.56 1.386 1.99 3.338 3.07 5.115 3.07 1.066 0 1.198-.24 1.198-.653v-1.504c0-.479.1-.575.438-.575.25 0 .676.125 1.67 1.084 1.138 1.137 1.325 1.648 1.965 1.648h1.677c.479 0 .718-.24.58-.713-.15-.471-.694-1.155-1.414-1.965-.391-.462-.977-.96-1.155-1.208-.249-.32-.178-.462 0-.747 0 0 2.043-2.878 2.256-3.855z",
  fill: "currentColor"
});

function SvgVk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVk);
export default __webpack_public_path__ + "static/media/vk.a47e0994.svg";
export { ForwardRef as ReactComponent };